module.exports = __webpack_public_path__ + "img/Logo_Sol.8a934a52.png";